﻿const lang = document.documentElement.lang ? document.documentElement.lang : 'en';

export default function (value, decimals = 0) {
    
    return Intl.NumberFormat(lang, {
        maximumFractionDigits: decimals
    }).format(value);
}